/* eslint-disable quotes, no-var, no-underscore-dangle, no-return-assign, no-cond-assign, no-confusing-arrow */
const SIDES = ["left", "right"];
const DUAL_SLOTS = ["outer", "inner"];
const layoutOf = (fitments) => ({
  axles: fitments.map((fitment, i) => ({ index: i + 1, fitment }))
});
function wheelPositionsOf(layout) {
  return layout.axles.flatMap(
    (axle) => SIDES.flatMap(
      (side) => axle.fitment === "single" ? [{ axle: axle.index, side }] : DUAL_SLOTS.map((slot) => ({ axle: axle.index, side, slot }))
    )
  );
}
const wheelCountOf = (layout) => layout.axles.reduce((total, axle) => total + (axle.fitment === "single" ? 2 : 4), 0);
function positionCode(ref) {
  const side = ref.side === "left" ? "L" : "R";
  const slot = ref.slot ? ref.slot === "outer" ? "O" : "I" : "";
  return `A${ref.axle}-${side}${slot}`;
}
const positionLabel = (ref) => `Axle ${ref.axle}, ${ref.side}${ref.slot ? ` ${ref.slot}` : ""}`;
const samePosition = (a, b) => a.axle === b.axle && a.side === b.side && a.slot === b.slot;
const sameLayout = (a, b) => a.axles.length === b.axles.length && a.axles.every((axle, i) => {
  var _a;
  return axle.fitment === ((_a = b.axles[i]) == null ? void 0 : _a.fitment);
});
const describeLayout = (layout) => `${layout.axles.length} axles: ${layout.axles.map((axle) => axle.fitment).join(", ")}`;
export {
  describeLayout,
  layoutOf,
  positionCode,
  positionLabel,
  sameLayout,
  samePosition,
  wheelCountOf,
  wheelPositionsOf
};
